const nf0 = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 })
const nf1 = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
const nf2 = new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const int = (n: number) => nf0.format(n)
export const dec1 = (n: number) => nf1.format(n)
export const pct = (n: number) => `${nf1.format(n)} %`
export const pct2 = (n: number) => `${nf2.format(n)} %`

export function signed(n: number, formatter: (x: number) => string = int): string {
  if (n === 0) return '±0'
  return (n > 0 ? '+' : '−') + formatter(Math.abs(n))
}

export function clockTime(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '–'
  return d.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })
}

export function dateTime(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '–'
  return d.toLocaleString('sv-SE', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
}
